import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  DialogContentText,
} from '@mui/material';
import { useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';

export default function CreateInviteCode({ onClose }: { onClose: () => void }) {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [saving, setSaving] = useState(false);
  const refresh = useRefresh();

  const handleConfirm = async () => {
    setSaving(true);
    try {
      // 创建时不需要参数，提交空对象
      await dataProvider.create('invite-codes', { data: {} });
      notify('Invite code created successfully', { type: 'success' });
      refresh();
      onClose();
    } catch (error: any) {
      console.error('Create error:', error);
      // 只显示成功提示，不显示错误提示
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <DialogTitle>Create Invite Code</DialogTitle>
      <DialogContent>
        <DialogContentText>create new code?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          cancel
        </Button>
        <Button onClick={handleConfirm} variant="contained" disabled={saving} autoFocus>
          create
        </Button>
      </DialogActions>
    </>
  );
}

